import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-popup-loader',
  templateUrl: './popuploader.component.html',
  styleUrls: ['./popuploader.component.css']
})
export class PopupLoaderComponent implements OnInit {

  @Input() flagLoading: boolean|any;
  @Input() size: number|any;
  @Input() statusMessage: string|any;
  @Input() type: string|any;
  @Input() statusMessageInner: string|any;
  @Input() transparent: string|any;
  

  constructor() { }

  ngOnInit() {
  }

}
